import {asLocalDateTime} from "../../../../util/timeDescription";
import {Clock, DateTimeFormatter, LocalDate, ZonedDateTime} from "js-joda";

export function activityTime(dateTimeISOString, clock = Clock.systemDefaultZone()) {
    if (!dateTimeISOString) {
        return "";
    }
    const zoneId = clock.zone();
    const zonedDateTime = ZonedDateTime.parse(dateTimeISOString).withZoneSameInstant(zoneId);
    const today = LocalDate.now(clock);
    const day = zonedDateTime.toLocalDate();
    const time = zonedDateTime.format(DateTimeFormatter.ofPattern("HH:mm"));
    if (today.equals(day)) {
        return `Today ${time}`;
    } else if (today.minusDays(1).equals(day)) {
        return `Yesterday ${time}`;
    }
    return asLocalDateTime(dateTimeISOString, clock);
}